/**
 * Timestamped entrance timeline — every line is `[GII entrance +Nms] …` from viewer mount.
 * Paste console output alongside what you saw on screen to debug phase gaps.
 */
let originMs = 0;
const buffer: string[] = [];
const MAX_BUFFER = 200;

export function resetEntranceTrace(): void {
  originMs = performance.now();
  buffer.length = 0;
  if (typeof window !== 'undefined') {
    (window as unknown as { __giiEntranceTrace?: () => string }).__giiEntranceTrace = () =>
      buffer.join('\n');
  }
}

export function entranceElapsedMs(): number {
  return originMs > 0 ? Math.round(performance.now() - originMs) : 0;
}

export function entranceTrace(event: string, detail?: Record<string, unknown>): string {
  const ms = entranceElapsedMs();
  const extra =
    detail && Object.keys(detail).length > 0
      ? ` ${Object.entries(detail)
          .map(([k, v]) => `${k}=${typeof v === 'number' ? (Number.isInteger(v) ? v : v.toFixed(3)) : v}`)
          .join(' ')}`
      : '';
  const line = `[GII entrance +${ms}ms] ${event}${extra}`;
  console.info(line);
  buffer.push(line);
  if (buffer.length > MAX_BUFFER) buffer.shift();
  return line;
}

export function getEntranceTraceLines(): readonly string[] {
  return buffer;
}

/** Log at most once per interval per key (avoids spamming the wait loop). */
const throttleLast = new Map<string, number>();

export function entranceTraceThrottled(
  key: string,
  intervalMs: number,
  event: string,
  detail?: Record<string, unknown>,
): void {
  const now = performance.now();
  const last = throttleLast.get(key) ?? 0;
  if (now - last < intervalMs) return;
  throttleLast.set(key, now);
  entranceTrace(event, detail);
}
